import * as Yup from "yup";

export const loginValidate = Yup.object().shape({
  mobile: Yup.string()
    .required("وارد کردن شماره همراه الزامیست")
    .min(11, "شماره همراه باید 11 رقمی باشد!")
    .max(11, "شماره همراه باید 11 رقمی باشد!"),
});

export const loginValidateWithOtp = Yup.object().shape({
  code: Yup.string()
    .required("وارد کردن کد OTP الزامیست")
    .min(6, "شماره همراه باید 6 رقمی باشد!")
    .max(6, "شماره همراه باید 6 رقمی باشد!"),
  password: Yup.string()
    .min(5, "رمز عبور باید حد اقل 5  است!")
    .required("وارد کردن رمز عبور الزامیست"),
});
